// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Hq-z","breadcrumbForward":"Iq-z","breadcrumbBack":"Jq-z","selected":"Kq-z"};